/*
 *
 * LeadersSummary actions
 *
 */

import {
  GET_LEADERS_SUMMARY_WATCHER,
  GET_LEADERS_SUMMARY_SUCCESS,
  GET_LEADERS_SUMMARY_FAILED,
  UPLOAD_TEMPLATE_LEADERS_WATCHER,
  UPLOAD_TEMPLATE_LEADERS_SUCCESS,
  UPLOAD_TEMPLATE_LEADERS_FAILED,
  SAVE_EXCEL_LEADERS_WATCHER,
  SAVE_EXCEL_LEADERS_SUCCESS,
  SAVE_EXCEL_LEADERS_FAILED,
  SAVE_EXCEL_LEADERS_PROGRESS,
} from "./constants"

// SAVE EXCEL COLLABORATORS
export function saveExcelLeadersWatcher(payload) {
  return {
    type: SAVE_EXCEL_LEADERS_WATCHER,
    payload,
  }
}

export function saveExcelLeadersSuccess(payload) {
  return {
    type: SAVE_EXCEL_LEADERS_SUCCESS,
    payload,
  }
}

export function saveExcelLeadersFailed() {
  return { type: SAVE_EXCEL_LEADERS_FAILED }
}

export function saveExcelLeadersProgress(payload) {
  return {
    type: SAVE_EXCEL_LEADERS_PROGRESS,
    payload,
  }
}

// GET SUMMARY COLLABORATORS
export function getLeadersSummaryWatcher() {
  return { type: GET_LEADERS_SUMMARY_WATCHER }
}

export function getLeadersSummarySuccess(payload) {
  return {
    type: GET_LEADERS_SUMMARY_SUCCESS,
    payload,
  }
}

export function getLeadersSummaryFailed() {
  return { type: GET_LEADERS_SUMMARY_FAILED }
}

// UPLOAD EXCEL
export function uploadTemplateLeadersWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_LEADERS_WATCHER,
    payload,
  }
}

export function uploadTemplateLeadersSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_LEADERS_SUCCESS,
    payload,
  }
}

export function uploadTemplateLeadersFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_LEADERS_FAILED,
    payload,
  }
}
